
    import '/home/ec2-user/Youlify-Design/components/watermark/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["watermark-demo-basic","watermark-demo-multi-line","watermark-demo-image","watermark-demo-custom","watermark-demo-portal"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/watermark/index.zh-CN.md?type=demo')
};